module.exports = __webpack_public_path__ + "assets/HKNova-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Medium.woff
// module id = 134
// module chunks = 0